export default "__VITE_ASSET__I3W1MJe7__"